import { useState } from 'react';
import { BrowserRouter as Router,
    Routes,
    Route,
    Link } from "react-router-dom";
import useFetch from '../useFetch';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

// === Pages

    function FeaturedPress() {
        const { isLoading, error, data } = useFetch(`${process.env.REACT_APP_BACKEND}/api/presses?filters[featured_on_landing][$eq]=true&populate=deep`)

        let press = []

        if (data) {
            
            press = data.data

            return (
                <div className="main-content-wrapper">
                    <h2 className="section-title">PRESS</h2>
                    
                    <div className="landing-freatured-press-container">
                        <h1>In The Loop</h1>
                        <svg className="press-intro-line" viewBox="0 0 1336 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_278_556)">
                            <mask id="path-1-inside-1_278_556" fill="white">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1352 748V506.5V241.5V-5.09131e-05L187.244 -0.000111948L40.6663 -5.09131e-05L-5.99998 44.8656L-6 286.404V461.596L-5.99998 703.134L40.6663 748L187.244 748L1352 748Z"/>
                            </mask>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1352 748V506.5V241.5V-5.09131e-05L187.244 -0.000111948L40.6663 -5.09131e-05L-5.99998 44.8656L-6 286.404V461.596L-5.99998 703.134L40.6663 748L187.244 748L1352 748Z" fill="#FEFEE4"/>
                            <path d="M1352 748H1357V753L1352 753L1352 748ZM1352 -5.09131e-05L1352 -5.00005L1357 -5.00005V-5.09131e-05H1352ZM187.244 -0.000111948L187.244 -5.00011L187.244 -5.00011L187.244 -0.000111948ZM40.6663 -5.09131e-05L37.201 -3.60444L38.6526 -5.00005L40.6663 -5.00005L40.6663 -5.09131e-05ZM-5.99998 44.8656L-11 44.8656L-11 42.7367L-9.46529 41.2612L-5.99998 44.8656ZM-6 286.404L-11 286.404L-11 286.404L-6 286.404ZM-6 461.596L-11 461.596V461.596H-6ZM-5.99998 703.134L-9.4653 706.739L-11 705.263L-11 703.134L-5.99998 703.134ZM40.6663 748L40.6663 753L38.6526 753L37.201 751.604L40.6663 748ZM187.244 748L187.244 753L187.244 753L187.244 748ZM1357 506.5V748H1347V506.5H1357ZM1347 506.5V241.5H1357V506.5H1347ZM1347 241.5V-5.09131e-05H1357V241.5H1347ZM1352 4.99995L187.244 4.99989L187.244 -5.00011L1352 -5.00005L1352 4.99995ZM187.244 4.99989L40.6663 4.99995L40.6663 -5.00005L187.244 -5.00011L187.244 4.99989ZM44.1316 3.60434L-2.53467 48.47L-9.46529 41.2612L37.201 -3.60444L44.1316 3.60434ZM-0.999982 44.8656L-1 286.404L-11 286.404L-11 44.8656L-0.999982 44.8656ZM-11 461.596V286.404H-1V461.596H-11ZM-11 703.134L-11 461.596L-1 461.596L-0.999982 703.134L-11 703.134ZM37.201 751.604L-9.4653 706.739L-2.53467 699.53L44.1316 744.396L37.201 751.604ZM187.244 753L40.6663 753L40.6663 743L187.244 743L187.244 753ZM1352 753L187.244 753L187.244 743L1352 743L1352 753Z" fill="#E5521C" mask="url(#path-1-inside-1_278_556)"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_278_556">
                            <rect width="1336" height="46" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                        <div className="landing-press-wrapper">
                            <div className="landing-press-card-wrapper">
                                 {press.map((entry) => 
                                        <div className="press-card-shadow">
                                            <div className="landing-press-card">
                                                <img className="landing-press-image" src={ `${ entry.attributes.Press_Image.data.attributes.url }` } />
                                                <div className="landing-press-info ">
                                                    <div className='landing-press-publication'>
                                                        <svg width="15" height="15" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.1571 11.081V6.40892L12.158 6.40984L12.1571 1.07704L11.0801 0L1.07696 0L0 1.07704L0 11.081L1.07696 12.158H11.0801L12.1571 11.081Z" fill="#FFCD29"/>
                                                        </svg>
                                                        <p><em>{entry.attributes.Publication}</em></p>
                                                    </div>
                                                    <a target="_blank" className='no-underline' href={ `${ entry.attributes.Link }` }>
                                                        <h4>{entry.attributes.Title}</h4>
                                                    </a>
                                                    <BlocksRenderer content={ entry.attributes.Pull_Quote } />
                                                </div>
                                                <div className="landing-press-card-bottom">
                                                    <div style={{backgroundImage: `linear-gradient(225deg, rgba(90, 50, 48, 1) 50%, rgba(0, 0, 0, 0) 50%)`}} className="bl-tr-diagonal"></div>
                                                    <div className="hexagon-middle-secondary-util"></div>
                                                    <div style={{backgroundImage: `linear-gradient(135deg, rgba(90, 50, 48, 1) 50%, rgba(0, 0, 0, 0) 50%)`}} className="tl-br-diagonal"></div>
                                                </div>
                                            </div>
                                        </div>
                                )}     
                            </div>    
                        </div>
                    </div>
                </div>
            );
        }
    }
    
    export default FeaturedPress;
